// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__PTICA","copyrightCustomLogin":"Copyright_copyrightCustomLogin__goKq4","links":"Copyright_links__84oYI"};